<template>
  <button class="omousikomi" type="submit">申し込み</button>
</template>

<style src="./application-button.css"></style>
